import apiClient from './apiClient';

export async function listOrders(params = {}) {
  const { data } = await apiClient.get('/api/admin/orders', { params });
  return data;
}

export async function updateOrderStatus(id, status) {
  const { data } = await apiClient.put(`/api/admin/order/${id}/status`, { status });
  return data;
}
